import axios from "axios";
import { baseUrl } from "../util";

export const getCompUseSoldTotal = ({
  businessId,
  setTotalObj = function () {
    return;
  },
  setSystemBoundaryProcessing = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/company-use-sold-total",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setTotalObj(response.data.total_obj);
      setSystemBoundaryProcessing(
        response.data.total_obj.systemboundary_category
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};
